import { render, staticRenderFns } from "./newReader.vue?vue&type=template&id=97be4536&scoped=true"
import script from "./newReader.vue?vue&type=script&lang=js"
export * from "./newReader.vue?vue&type=script&lang=js"
import style0 from "./newReader.vue?vue&type=style&index=0&id=97be4536&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97be4536",
  null
  
)

export default component.exports